import { FC, useCallback, useState } from "react";
import IconButton from "../iconButton";
import { Email } from "../../../../../../../components/icons";
import DistributionEditModal from "../../../distributionAndNotification/distributions/distributionEditModal";
import { useParams } from "react-router-dom";
import { ReceiverTypeEnum } from "../../../../../../../types/distributionType";
import { I18n } from "react-redux-i18n";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../store";

type Props = {
  readonly showButton?: boolean;
  readonly openModal?: boolean;
};

const EmailButton: FC<Props> = ({ showButton = true, openModal }) => {
  const { id: surveyId } = useParams();
  const [modalOpen, setModalOpen] = useState(openModal ?? false);
  const { currentChannel, currentDistribution } = useSelector((state: RootState) => ({
    currentChannel: state.distributionChannels.current,
    currentDistribution: state.distributions.current,
  }));

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  return (
    <>
      {showButton && <IconButton icon={<Email />} label={"E-mail"} onClick={handleClick} />}
      {modalOpen && (
        <DistributionEditModal
          descriptionInitial={currentChannel?.description ?? I18n.t("emailDistribution")}
          distributionChannelId={currentChannel?.channelId}
          receiverType={ReceiverTypeEnum.EMAIL}
          onCancel={handleCloseModal}
          data={currentDistribution}
          surveyId={surveyId}
          open={modalOpen}
        />
      )}
    </>
  );
};

export default EmailButton;
